import type { Item } from "./types";

export type TextItemDetailState =
  | "error"
  | "loading"
  | "not-found"
  | "ready"
  | "unsupported";

export function resolveTextItemDetailState({
  error,
  item,
  pending,
}: {
  error: unknown;
  item: Item | undefined;
  pending: boolean;
}): TextItemDetailState {
  if (pending) return "loading";
  if (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    error.status === 404
  ) {
    return "not-found";
  }
  if (error) return "error";
  if (!item) return "not-found";
  return item.format === "text" ? "ready" : "unsupported";
}
